<template>
  <a
    :href="portalUrl"
    :class="$style.container"
  >
    <img
      v-if="$mq.phone"
      src="~@images/bilderlings-logo-short.svg"
      alt=""
      :class="$style.logoImage"
    >
    <img
      v-else
      src="~@images/bilderlings-logo.svg"
      alt=""
      :class="$style.logoImage"
    >
  </a>
</template>

<script>
  export default {
    props: {
      portalUrl: {
        type: String
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins";

  /**
   * Container
   */
  .container {
    display: block;
  }

  /**
   * DESKTOP
   */
  @include desktop {
    .logoImage {
      display: block;
      width: 130px;
      height: 35px;
      margin: 0px 30px;
    }
  }

  /**
   * PHONE
   */
  @include phone {
    .logoImage {
      display: block;
      width: 50px;
      height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue